export const isEmpty = (array) => {
  if (!array) return true;
  if (typeof array !== typeof []) return true;
  if (array.length <= 0) return true;
  return false;
};
